var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(!_vm.isPrintReady)?_c('router-view'):_vm._e(),_c('img',{attrs:{"id":"print_image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }